import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { MdErrorOutline } from "react-icons/md";

export function RouteErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    let message = "An unexpected error occurred.";
    if (isRouteErrorResponse(error)) {
        message = error.statusText || message;
    } else if (error instanceof Error) {
        message = error.message;
    }

    return (
        <Center h="100vh">
            <Stack align="center" gap="md" maw={480} ta="center" px="xl">
                <MdErrorOutline size={40} color="var(--mantine-color-red-6)" />
                <Title order={3}>Something went wrong</Title>
                <Text c="dimmed" size="sm">
                    {message}
                </Text>
                <Button onClick={() => navigate("/")}>Go to start</Button>
            </Stack>
        </Center>
    );
}
